<template>

  <VDialog v-model="dialogLoading" :max-width="700">
    <VCard class="pa-sm-10 pa-5">
      <VCardTitle class="text-center">Cargando información</VCardTitle>
      <VProgressLinear indeterminate color="primary"></VProgressLinear>
    </VCard>
  </VDialog>
  <!-- The Modal -->
  <div class="modal fade custom-modal" id="msgSuccessModal" style="border-radius: 15px;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <!-- <div class="modal-header">
          <h4 class="modal-title">Tu postulación fue realiza con éxito</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
          <span>&times;</span>
          </button>
        </div> -->
        <img src="@/assets/talento_agv/img/msj_post_exitosa.png" alt="">
        <!-- <router-link to="/ofertas_laborales" class="btn btn-success pt-2" tabindex="-1">Ir al portal de empleos</router-link> -->
        <a 
          href="../../" 
          class="btn btn-primary price-btn btn-block"
          >
          Ir al portal de empleos
        </a>
        <!-- Modal body -->
        <!-- <div class="modal-body">
          <form>
            <div class="form-group">
              <label>Category Name</label>
              <input type="text" class="form-control" placeholder="Enter Category Name" />
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-primary btn-block">Submit</button>
            </div>
          </form>
        </div> -->
      </div>
    </div>
  </div>
  <!-- /The Modal -->

        <!-- Modal body -->
        <div ref="questionModal" class="modal fade custom-modal" id="questionsModal" role="dialog">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">Preguntas de la Oferta</h4>
                <button type="button" class="close" data-bs-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>

              <!-- Modal body -->
              <div class="modal-body">
                <form @submit.prevent="completeApplication">
                  <div v-for="(question, index) in questions" :key="index" class="form-group">
                    <label>{{ index + 1 }}.- {{ question.pregunta_text }}</label>
                    <input v-if="question.pregunta_type === 'A'" type="text" class="form-control" v-model="question.answer" placeholder="" />
                    <!-- Agrega aquí otras condiciones para diferentes tipos de preguntas, si es necesario -->
                    <div v-if="question.pregunta_type === 'C'">
                      <div v-for="option in question.options" :key="option.opcion_id" class="form-check">
                        <input class="form-check-input" type="radio" :name="'question' + index" :value="option.opcion_text" v-model="question.answer">
                        <label class="form-check-label">{{ option.opcion_text }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="mt-4">
                    <!-- <button type="submit" class="btn btn-primary btn-block text-light">Completar Postulación</button> -->
                    <a href="javascript:void(0);" class="btn btn-primary price-btn btn-block" @click = "completeApplication" >
                      Completar Postulación
                    </a>
                  </div>
                  <div class="row justify-content-center mb-5">
                    <div v-if="showErrorMessage" class="alert alert-danger alert-dismissible fade show col-md-6" role="alert" style="position:absolute; z-index: 2; justify-content:center">
                      <strong>Error:</strong> {{ errorMessage }}
                      <button type="button" class="btn-close" @click="showErrorMessage = false" aria-label="Close"></button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
  <!-- /The Modal -->

  <!-- The Modal -->
  <div class="modal fade custom-modal" id="inv_crear_cuenta">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <!-- <h2 class="mt-5 center">¡Potencia tu carrera con nosotros!</h2> -->
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          
          <img src="@/assets/img/work4.png" alt="" class="center" width="60%" style="margin-left:20%;">
          <!-- <h3 class="mt-5 mb-4 center">¿Listo para dar el siguiente paso en tu vida profesional?</h3> -->
          <h3 class="mt-5 center">¡Accede a muchas oportunidades!</h3>
          <h5 class="mt-4 center">Ingresa o registrate ahora en nuestra plataforma para poder postular.</h5>
          <button 
            type="button" 
            class="btn-agv-dos" 
            data-bs-dismiss="modal"
            style="display:block; 
            margin: auto; 
            width:150px; 
            padding: 12px; 
            border-radius: 10px; 
            margin-top: 18px; 
            margin-bottom: 10px;
            text-align: center;"
          >
            <router-link 
              to="/crear_cuenta" 
              style="color: inherit; text-decoration: none;">
              Crear cuenta
            </router-link>
          </button>
          <!-- <router-link 
          to="/crear_cuenta" 
          class="btn-agv-dos" 
          style="display:inline-block; 
          width:150px; 
          padding: 12px; 
          border-radius: 10px; 
          margin-top: 18px; 
          margin-bottom: 10px;
          text-align: center;"
          data-bs-dismiss="modal"
          >
            Crear Cuenta
          </router-link> -->
        </div>
      </div>
    </div>
  </div>
  <!-- /The Modal -->

  <!-- Blog Sidebar -->
  <div class="col-lg-3 col-md-12 sidebar-right theiaStickySidebar project-client-view">
    <div class="stickysidebar">
      <div class="card budget-widget">
        <div>
          <a 
          href="javascript:void(0);" 
          class="btn btn-agv-dos btn-block text-white"
          @click="postular"
          >
          Postular
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- /Blog Sidebar -->
</template>

<script>
import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
import {router} from "@/router";
import {Modal} from "bootstrap";

export default {
  data(){
    return{
      questions: [],
      showErrorMessage: false,
      errorMessage: null,
      questionModal: null,
      successModal: null,
      dialogLoading: false,

      newAccountModal: null,
      questionsModal: null,
      msgSuccessModal: null,

      usuario: null,
      id_joboffer: null,
    }
  },
  mounted() {
    this.id_joboffer = this.$route.query.id;
    this.newAccountModal = new Modal(document.getElementById('inv_crear_cuenta'));
    this.questionModal = new Modal(document.getElementById('questionsModal'));
    this.msgSuccessModal = new Modal(document.getElementById('msgSuccessModal'));
    this.usuario = JSON.parse(localStorage.getItem('userData'));
  },
  methods:{
    postular(){
      console.log("información del usuario", this.usuario)
      if(this.usuario == null){
        this.newAccountModal.show();
      }else{
        this.getQuestions();
      }
    },
    getQuestions(){
      const yo = this

      const data = JSON.stringify({
        id_job_offer : yo.id_joboffer
      })
      yo.dialogLoading = true;

      const config = {
        method: 'post',
        url: '/talentoagv/getQuestions/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']

            yo.questions = resultado
            if(!response.data['is_error'] && response.data['result'].length > 0){
              yo.questionModal.show()
            }else{
              yo.completeApplication()
            }

          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error("Error consulte con su administrador", 'Error')
        })
        .finally(function (){
          yo.dialogLoading = false;
        })
    },

    completeApplication() {
      const yo = this;
      this.showErrorMessage = false
      this.errorMessage = ''

      let iq = yo.questions.findIndex((question, index) => question.answer == null || question.answer == '')
      if(iq != -1){
        this.showErrorMessage = true
        this.errorMessage = 'Complete todas las preguntas'
        return false
      }
      this.dialogLoading = true
      this.questionModal.hide()

      const answers = yo.questions.map(q => ({
        question_id: q.pregunta_id,
        answer: q.answer
      }));

      const data = JSON.stringify({
        answers : answers,
        id_applicant : yo.usuario.id_usuario,
        id_job_offer : yo.id_joboffer,
      });

      const config = {
        method: 'post',
        url: '/talentoagv/completeApplication/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      };

      axiosIns(config)
        .then(function (response) {
          if (response.data['is_error'] === false) {
            yo.$toastr.success('Postulación completada', 'Éxito');
            yo.msgSuccessModal.show()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(error.response.data['message'], 'Error');
        })
        .finally(function (){
          yo.dialogLoading = false
        });
    },
  }
}
</script>
<style>
.center{
  text-align: center;
}
</style>
